import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-slate-950 overflow-hidden pt-12 pb-20 px-4 md:pt-20 md:pb-32" data-id="element-59">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-60">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl mix-blend-screen" data-id="element-61" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl mix-blend-screen" data-id="element-62" />
      </div>

      <div className="relative max-w-6xl mx-auto text-center z-10" data-id="element-63">
        {/* Pre-headline */}
        <div className="inline-flex items-center gap-2 bg-slate-900/80 border border-slate-800 rounded-full px-4 py-1.5 mb-8 backdrop-blur-sm" data-id="element-64">
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-65" />
          <span className="text-xs md:text-sm font-medium text-slate-300 uppercase tracking-wider" data-id="element-66">
            Para los que vinieron a Conquistar
          </span>
        </div>

        {/* Main Headlines */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6 uppercase tracking-tight" data-id="element-67">
          ¿Hiciste todo bien y aún así sientes que{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600" data-id="element-68">
            el sistema te ganó?
          </span>
        </h1>

        <h2 className="text-xl md:text-3xl font-medium text-slate-300 max-w-4xl mx-auto mb-8 leading-relaxed" data-id="element-69">
          Es hora del Reset. El Manual Prohibido para los que quieren{' '}
          <span className="text-white font-bold border-b-2 border-teal-500" data-id="element-70">
            Facturar como Dueños del Juego
          </span>
          , no trabajar como empleados.
        </h2>

        {/* Mockup Image */}
        <div className="relative mx-auto max-w-4xl mb-12 group" data-id="element-71">
          <div className="absolute -inset-1 bg-gradient-to-r from-teal-500 to-yellow-500 rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-1000" data-id="element-72"></div>
          <img src="https://cdn.magicpatterns.com/uploads/qp37bmRZVYbPjnu5XeeHtG/heylloyd-image-1771391096362.png" alt="El Reset de los 30+ Mockup" className="relative rounded-2xl shadow-2xl border border-slate-800 w-full transform hover:scale-[1.01] transition duration-500" data-id="element-73" />
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-4" data-id="element-74">
          <button className="group relative bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-400 hover:to-yellow-500 text-slate-950 font-bold text-xl md:text-2xl py-5 px-10 rounded-xl shadow-[0_0_40px_-10px_rgba(234,179,8,0.5)] transition-all transform hover:-translate-y-1" onClick={() => document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-75">
            <span className="flex items-center gap-3" data-id="element-76">
              QUIERO EL RESET AHORA
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-77" />
            </span>
            <div className="absolute inset-0 rounded-xl ring-2 ring-white/20 group-hover:ring-white/40" data-id="element-78" />
          </button>
          <p className="text-sm text-slate-400 flex items-center gap-2" data-id="element-79">
            <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-80" />
            Acceso Inmediato - Garantía de 30 Días
          </p>
        </div>
      </div>
    </section>;
}